import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable'
import { LinkText } from '@/components/atoms'
import { OrderState } from '../../Common/OrderState'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {useOnlineOrderList} from '@/hooks/useOnlineOrderList'
import {useResetSelectionOnFilterChange} from '@/hooks/useResetSelectionOnFilterChange'
import {useState, useRef} from 'react'
import {useNavigate} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {showOrderTypeFeature} from '@/utils/commons'
import "./onlineOrderList.scss"

const createCellDataMapperObj = (navigate, countryCode) => {
  // Check if Order Type column is visible (Colombia only)
  const isOrderTypeVisible = showOrderTypeFeature(countryCode);

  return {
    orderId: {
      cellData: ({ row: { original } = {} }) => {
        const typeOfOrder = isOrderTypeVisible && original?.orderType ? `?typeOfOrder=${original.orderType}` : '';
        const baseUrl = `/orders/online/${original?.orderId}`;
        const url = `${baseUrl}${typeOfOrder}`;
        
        return (
          <LinkText
            text={original?.orderId}
            id={`${original?.orderId} ${original?.orderId}`}
            handleClick={() => navigate(url)}
          />
        );
      },
      linkHandler: (row) => {
        const typeOfOrder = isOrderTypeVisible && row?.orderType ? `?typeOfOrder=${row.orderType}` : '';
        const baseUrl = `/orders/online/${row?.orderId}`;
        const url = `${baseUrl}${typeOfOrder}`;
        return navigate(url);
      },
      linkLabel: (row) => row?.orderId || '—',
    },
  storeId: {
    cellData: ({ row: { original } = {} }) => (
      <LinkText
        text={original?.storeId}
        id={`${original?.storeId} ${original?.storeId}`}
        handleClick={() => navigate(`/stores/store/${original?.storeId}`)}
      />
    ),
    linkHandler: (row) => navigate(`/stores/store/${row?.storeId}`),
    linkLabel: (row) => row?.storeId || '—',
  },
  orderState: {
    cellData: ({ row: { original } = {} }) => <OrderState state={original?.orderState} />,
    className: (row) => row?.orderState,
  },
  orderType: {
    cellData: ({ row: { original } = {} }) => {
      const orderType = original?.orderType;
      return (orderType && orderType !== '') ? orderType : '—';
    },
  },
  };
};

const OnlineOrderList = () => {
  const navigate = useNavigate()
  const countryCode = useSelector(selectCountryCode) || localStorage.getItem("countryCode");

  const [rowSelected, setRowSelected] = useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)
  
  // Ref to access CustomDataTable's resetSelection function
  const resetSelectionRef = useRef(null)
 
  const {
    onlineOrderData,
    OnlineOrderListColConfigData,
    pageIndex,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    searchArr,
    onDownloadBtnClick,
    isLoading,
    handleResetAll
  } = useOnlineOrderList()

  // Handler for row selection changes
  const handleRowSelect = (selectedRecords, isAll) => {
    setRowSelected(selectedRecords)
    setIsSelectAll(isAll)
  }

  // Reset selected rows when orderType filter changes
  useResetSelectionOnFilterChange(searchArr, resetSelectionRef, 'orderType')

  const cellDataMapperObj = createCellDataMapperObj(navigate, countryCode);
  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj, OnlineOrderListColConfigData);

  const onDownloadClick = async () => {
    const ids = rowSelected?.map(item => item?.orderId)
    onDownloadBtnClick(ids)
  }

  return (
    <div className="orderContainer flex flex-col">
      <div className="relative" style={{backgroundColor: '#1D1D1D'}}>
        <CustomDataTable
          columns={cellDataMappedCols}
          records={onlineOrderData?.data  || []}
          isLoading={isLoading}
          pageSize={10}
          totalRecords={onlineOrderData?.totalRecords || 0}
          setPageIndex={setPageIndex}
          handleSorting={setSortingObj}
          setSearchArry={setSearchArry}
          searchArr={searchArr}
          onResetAll={handleResetAll}
          onRowSelect={handleRowSelect}
          onDownload={onDownloadClick}
          showDownload={true}
          isSelectAll={isSelectAll}
          pageIndex={pageIndex}
          onResetSelectionRef={resetSelectionRef}
        />
        {onlineOrderData?.totalRecords && <div className="txtRightAlign">{onlineOrderData?.totalRecords} total items</div>}
      </div>
    </div>
  )
}

export default OnlineOrderList
